import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConstantConfig } from '../config/constant.config';
import { PathConfig } from '../config/path.config';
import { ClientDetailService } from './client-detail-service';
import { LocalStorageService } from './local-storage.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private http: HttpClient, private router: Router, private clientDetailService: ClientDetailService, private msgService: MessageService, private localStorageService: LocalStorageService
  ) {
  }

  init(): Promise<boolean> {
    return new Promise((resolve, reject) => {

      const windowURL = window.location.pathname.split("/");
      const clientId = (windowURL.length > 1) ? windowURL[1] : '';

      const url = `${PathConfig.LS_CLIENTS_DETAIL}/${clientId}`;
      if (!clientId) {
        resolve(false);
        window.location.href = environment.LOGIN_URL;

      }
      this.http.get(url).subscribe((response) => {
        this.clientDetailService.setClientInfo(response);
        sessionStorage.setItem(ConstantConfig.CLIENT_SLUG, clientId);
        resolve(true);
      }, (err) => {
        resolve(false);
        const status = err?.status || '';
        //this work in local not in deployed version dev/QA for service down>incorrect slug>error page show
        // if (status === 503) {
        //   const currentClientSlug = window.location.pathname.split("/")[1];
        //   const token = this.localStorageService.get(currentClientSlug + "_" + ConstantConfig.AUTH_TOKEN)
        //   !token && this.router.navigate(['/error-404'], { queryParams: { fp: 'F' }, replaceUrl: true });
        // }
        switch (status) {
          case 400:
            this.msgService.showError(err?.error?.message || 'Service Unavailable');
            this.router.navigate(['/error-404'], { queryParams: { fp: 'F' }, replaceUrl: true });
            break;
          case 404:
            // this.router.navigate(['/error-404'], { queryParams: { fp:'F'} });
            this.msgService.showError(err?.error?.message || 'Service Unavailable');
            break;
          case 403:
            this.router.navigate(['/error-403'], { queryParams: { fp: 'F' } });
            break;
          default:
            // this.router.navigate(['/error-404'], { queryParams: { fp: 'F' } });
            this.msgService.showError(err?.error?.message || 'Service Unavailable');
            break;
        }

      })
    });
  }
}